import React, { Suspense, useMemo } from 'react';

// Icons
import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import CheckIcon from '@mui/icons-material/Check';
import AddIcon from '@mui/icons-material/Add';

// Images
import MercadoshopsIcon from '../../../assets/images/Integrations/MercadoshopsIcon.png';
import HechoAMedidaIcon from '../../../assets/images/Integrations/HechoAMedidaIcon.png';
import WooCommerceIcon from '../../../assets/images/Integrations/WooCommerceIcon.png';
import TiendanubeIcon from '../../../assets/images/Integrations/TiendanubeIcon.png';

// Kit
import { Card, Button, Badge } from '@/components/ui';

const CardIntegration = ({ title, origin, handleShowModal, handleShowVideo }) => {

    const isConnected = origin === title;
    const isComingSoon = title === 'Woo Commerce';
    const isCustom = title === 'Hecho a medida';

    const handleShowIcons = () => {
        switch (title) {
            case 'Tiendanube':
                return TiendanubeIcon;
            case 'Mercado Shops':
                return MercadoshopsIcon;
            case 'Woo Commerce':
                return WooCommerceIcon;
            case 'Hecho a medida':
                return HechoAMedidaIcon;
            default:
                break;
        }
    }

    const originInFormat = useMemo(() => origin?.toLowerCase(), [origin]);
    const connectedByFormat = originInFormat === title.toLowerCase();

    return (
        <Suspense>
            <Card hover className="flex h-full flex-col p-5 text-left">
                <div className="mb-3 flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
                    <div className="flex items-center gap-3">
                        <img
                            className="h-11 w-11 shrink-0 rounded-sm object-contain"
                            width="44"
                            src={handleShowIcons()}
                            alt={title}
                        />
                        <h3 className={`text-[17px] font-bold leading-tight tracking-[-0.01em] ${isComingSoon ? 'text-muted-foreground' : 'text-foreground'}`}>
                            {title}
                        </h3>
                    </div>
                    {(isConnected || connectedByFormat) ? (
                        <Badge variant="success" size="sm" className="shrink-0">
                            <span className="h-1.5 w-1.5 rounded-full bg-success" />
                            Conectado
                        </Badge>
                    ) : isComingSoon ? (
                        <Badge variant="neutral" size="sm" className="shrink-0">Próximamente</Badge>
                    ) : (
                        <Badge variant="neutral" size="sm" className="shrink-0">Sin conectar</Badge>
                    )}
                </div>

                <p className="mb-5 flex-1 text-sm text-muted-foreground">
                    {isCustom
                        ? 'Conectá tu Pagina Web en pocos segundos siguiendo nuestro tutorial y luego apretando en + Conectar.'
                        : `Conectá whatsPRO con tu E-commerce de ${title} en segundos con nuestra integración automática.`}
                </p>

                <div className="flex flex-wrap items-center gap-2">
                    {(isConnected || connectedByFormat) ? (
                        <Button
                            variant="success"
                            size="sm"
                            className="pointer-events-none"
                            onClick={() => handleShowModal(origin)}
                        >
                            <CheckIcon sx={{ fontSize: '1rem' }} /> Conectado
                        </Button>
                    ) : isComingSoon ? (
                        <Button variant="subtle" size="sm" disabled>Próximamente</Button>
                    ) : (
                        <Button
                            variant="default"
                            size="sm"
                            onClick={() => handleShowModal(origin)}
                        >
                            {!isCustom && <AddIcon sx={{ fontSize: '1.1rem' }} />} Conectar
                        </Button>
                    )}
                    {isCustom && (
                        <Button variant="outline" size="sm" onClick={handleShowVideo}>
                            <PlayArrowOutlinedIcon sx={{ fontSize: '1.1rem' }} /> Ver Tutorial
                        </Button>
                    )}
                </div>
            </Card>
        </Suspense>
    )
}

export default CardIntegration;
